import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/AddSemitrailer';
import { useAuthValidation } from '../../utils/hooks';

const AddSemitrailerPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default AddSemitrailerPage;
